import { action } from 'satcheljs/lib/legacy';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
export default action('setIRMData')(function setIRMData(viewState, IRMData) {
    if (canSetIRMData(viewState)) {
        if (IRMData) {
            viewState.IRMData = IRMData;
        }
        else if (viewState.IRMData) {
            // If there was IRM data, just set template id to null so that when save draft/send, we know we need to clear the compliance id
            viewState.IRMData.RmsTemplateId = null;
        }
    }
});
function canSetIRMData(viewState) {
    var config = getUserConfiguration();
    if (config.SegmentationSettings && !config.SegmentationSettings.Irm) {
        return false;
    }
    var IRMData = viewState.IRMData;
    return (IRMData == null ||
        (IRMData.RightsManagedMessageDecryptionStatus &&
            IRMData.RightsManagedMessageDecryptionStatus != 0 /* Success */) ||
        IRMData.IsOwner ||
        IRMData.ExportAllowed);
}
//# sourceMappingURL=setIRMData.js.map